import { EvtHeader } from "components/header";
import React from "react";
import ApplicantForm from "../form";
import { useParams } from "react-router-dom";

const CreateOpeningApplicant = () => {

  const { openingId } = useParams();

  return (
    <div className="flex-1">
      <EvtHeader title="Create Applicant" />
      <div className="p-6 max-w-md">
        <ApplicantForm openingId={openingId} />
      </div>
    </div>
  );
};

export default CreateOpeningApplicant;
